import React from "react";
import Input from "components/input";
import DatePicker from "components/date-picker";
import { Controller } from "react-hook-form";

interface FleetComplianceTabProps {
  form: any;
  t: any;
}

const FleetComplianceTab = ({ form, t }: FleetComplianceTabProps) => {
  const { register, control, formState: { errors } } = form;

  return (
    <div className="grid grid-cols-2 gap-6">
      <Controller
        name="odometer"
        control={control}
        render={({ field, fieldState }) => (
          <Input
            label={t("label-odometer")}
            required
            type="number"
            value={field.value ?? ""}
            onChange={(e) => {
              const val = e.target.value === "" ? "" : Number(e.target.value);
              field.onChange(val);
            }}
            onBlur={field.onBlur}
            error={fieldState.error}
            placeholder={t("placeholder-odometer")}
            rightIcon={<span className="text-xs font-medium">{t("unit-km")}</span>}
            data-testid="input-odometer"
          />
        )}
      />
      <Controller
        name="lastMaintenanceDate"
        control={control}
        render={({ field, fieldState }) => (
          <DatePicker
            label={t("label-last-maintenance")}
            value={field.value}
            onChange={field.onChange}
            error={fieldState.error}
            placeholder="dd / mm / yyyy"
          />
        )}
      />
    </div>
  );
};

export default FleetComplianceTab;
